(function () {
  if (window.BfQuiz) { return; }
  var dlgs = document.querySelectorAll('dialog.bf-quiz');
  if (!dlgs.length) { return; }
  for (var d = 1; d < dlgs.length; d++) { dlgs[d].remove(); }
  var dlg = dlgs[0];
  var DATA = JSON.parse(dlg.querySelector('[data-bf-quiz-data]').textContent);
  /* Alle teksten komen uit locale-keys product.quiz.* (DATA.t); [naam] in een tekst is een plaatshouder voor tp(). */
  var T = DATA.t;
  function tp(str, vars) { return String(str).replace(/\[(\w+)\]/g, function (m, k) { return vars && vars[k] != null ? vars[k] : m; }); }
  function room(key, size, moist, dims) { return { key: key, label: T['room_' + key], desc: T['room_' + key + '_desc'], of: T['room_' + key + '_of'], size: size, moist: moist, dims: dims }; }

  /* Maten (dims) als tekst met komma; num() leest komma en punt, fmt() schrijft het decimaalteken van de taal. */
  var ROOMS = [
    room('woonkamer', 1, 0, ['6', '4,5', '2,6']),
    room('slaapkamer', 0, 0, ['4', '3,5', '2,6']),
    room('badkamer', 0, 2, ['3', '2,5', '2,6']),
    room('kelder', 2, 2, ['7', '5', '2,3']),
    room('zolder', 1, 0, ['6', '4', '2,4']),
    room('wasruimte', 0, 2, ['3', '2,5', '2,6']),
    room('garage', 3, 0, ['7', '6', '2,5']),
    room('caravan', 0, 0, ['5', '2,3', '2'])
  ];
  var SIZES = [0, 1, 2, 3].map(function (i) { return { label: T['size_' + i], range: T['size_' + i + '_range'], example: T['size_' + i + '_example'], avg: T['avg_size_' + i] }; });
  var HUM_STYLE = [
    { color: '#1F8A5B', tint: 'rgba(31,138,91,0.12)', icon: 'droplet' },
    { color: '#C9821E', tint: 'rgba(201,130,30,0.14)', icon: 'droplets' },
    { color: '#C0473C', tint: 'rgba(192,71,60,0.12)', icon: 'rain' }
  ];
  var HUMS = HUM_STYLE.map(function (st, i) { return { label: T['hum_' + i], rh: T['hum_' + i + '_rh'], color: st.color, tint: st.tint, icon: st.icon, signs: T['hum_' + i + '_signs'] }; });
  var SIGNS = [0, 1, 1, 1, 2, 2].map(function (lvl, i) { return { text: T['sign_' + i], lvl: lvl }; });
  var ROOM_POINT = {};
  ROOMS.forEach(function (r) { ROOM_POINT[r.key] = T['point_' + r.key]; });
  var TIERS = [12, 16, 20, 25];
  var PRODUCTS = {};
  DATA.products.forEach(function (p) { PRODUCTS[p.cap] = p; });
  var PROGRESS = [T.progress_room, T.progress_size, T.progress_hum, T.progress_result];
  /* Is er in deze markt maar één leverbaar model (UK: alleen de Orbit 20L), dan adviseren we altijd dat model en tonen we geen alternatief. */
  var AVAIL = DATA.products.filter(function (p) { return p.available !== false; });
  var SINGLE = AVAIL.length === 1 ? AVAIL[0] : null;
  var ICONS = {
    x: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>',
    arrow: '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>',
    arrowLeft: '<path d="m12 19-7-7 7-7"/><path d="M19 12H5"/>',
    back: '<path d="m15 18-6-6 6-6"/>',
    up: '<path d="m18 15-6-6-6 6"/>',
    down: '<path d="m6 9 6 6 6-6"/>',
    check: '<path d="M20 6 9 17l-5-5"/>',
    gift: '<rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"/>',
    rotate: '<path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/>',
    ruler: '<path d="M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z"/><path d="m14.5 12.5 2-2"/><path d="m11.5 9.5 2-2"/><path d="m8.5 6.5 2-2"/><path d="m17.5 15.5 2-2"/>',
    help: '<circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/>',
    minus: '<path d="M5 12h14"/>',
    plus: '<path d="M5 12h14"/><path d="M12 5v14"/>',
    gauge: '<path d="m12 14 4-4"/><path d="M3.34 19a10 10 0 1 1 17.32 0"/>',
    droplet: '<path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z"/>',
    droplets: '<path d="M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z"/><path d="M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97"/>',
    rain: '<path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242"/><path d="M16 14v6"/><path d="M8 14v6"/><path d="M12 16v6"/>',
    truck: '<path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/>',
    shield: '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/>',
    star: '<path d="M12 2.5l2.9 6.1 6.7.8-4.9 4.6 1.3 6.6L12 17.3l-6 3.3 1.3-6.6L2.4 9.4l6.7-.8z"/>'
  };
  function ic(name, size) {
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICONS[name] + '</svg>';
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function num(s) { return parseFloat(String(s).replace(',', '.')); }
  function fmt(n) { return (Math.round(n * 10) / 10).toString().replace('.', T.decimal); }
  function dims(r) { return r.dims.map(function (d) { return fmt(num(d)); }); }
  /* Actieregel: neemt de tekst van de aankondigingsbalk over (sectie announcement-bar2, één plek voor de lopende
     actie). Die balk staat boven de quiz in de DOM; voor de zekerheid vullen we na het renderen én bij window.load.
     Geen balk, lege tekst of balk verborgen (actie afgelopen): geen regel. */
  function giftLine() {
    return '<p class="bf-quiz__gift" hidden></p>';
  }
  function promoText() {
    var bar = document.querySelector('.kv-announcement-bar');
    if (!bar || getComputedStyle(bar).display === 'none') return '';
    var el = bar.querySelector('.kv-announcement-text');
    var t = el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    if (!t) return '';
    /* 1. gratis cadeau ("+ gratis hygrometer", "free hygrometer"); in de UK-market is er geen cadeau */
    var m = DATA.market === 'uk' ? null : t.match(/\b(gratis|free)\s+([^+,.·|:()]+?)(?=\s*(?:[+,.·|(]|$))/i);
    if (m && !/verzending|shipping|delivery/i.test(m[2])) {
      var gift = m[2].trim().toLowerCase();
      return /^free$/i.test(m[1]) ? 'Free ' + gift + ' with your order' : 'Gratis ' + gift + ' bij je bestelling';
    }
    m = DATA.market === 'uk' ? null : t.match(/\b(mystery gift|cadeau|gift)\b/i);
    if (m) { return /[a-z]/.test(t) && /\b(off|order|free)\b/i.test(t) ? 'Free ' + m[1].toLowerCase() + ' with your order' : 'Gratis ' + m[1].toLowerCase() + ' bij je bestelling'; }
    /* 2. kortingsbedrag ("tot €160 korting", "€50 korting", "30% korting", "£50 off", "up to 30% off") */
    m = t.match(/(?:^|\s)((?:tot|up to)\s+)?((?:€|£)\s?\d+(?:[,.]\d+)?|\d+\s?%)\s*(korting|off)\b/i);
    if (m) {
      var pre = m[1] ? m[1].trim() : '';
      return (pre ? cap(pre) + ' ' : '') + m[2].replace(/\s/g, '') + ' ' + m[3].toLowerCase();
    }
    /* 3. anders de naam van de actie vóór de dubbele punt, als die "sale" bevat */
    m = t.match(/^([^:]{3,40}?)\s*:/);
    return m && /sale|actie|deal/i.test(m[1]) ? m[1].trim() : '';
  }
  function applyGift() {
    var txt = promoText();
    if (!txt) return;
    var els = elMain.querySelectorAll('.bf-quiz__gift[hidden]');
    for (var i = 0; i < els.length; i++) {
      els[i].innerHTML = '<span class="bf-quiz__ic-accent">' + ic('gift', 18) + '</span><span>' + esc(txt) + '</span>';
      els[i].removeAttribute('hidden');
    }
  }
  /* Prijzen komen uit Liquid in de valuta van de markt (NL €, UK £); het teken volgt de actieve valuta. */
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var SYM = { EUR: '€', GBP: '£', USD: '$', CHF: 'CHF ' }[CUR] || (CUR + ' ');
  function eur(cents) { var n = cents / 100; return SYM + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2).replace('.', CUR === 'EUR' ? ',' : '.')); }
  function bucket(a) { return a < 20 ? 0 : a < 30 ? 1 : a < 40 ? 2 : 3; }
  function track(event, data) { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: event }, data)); }
  function narrow() { return window.innerWidth < 640; }
  function cap(t) { return t.charAt(0).toUpperCase() + t.slice(1); }

  var INITIAL = { step: 0, room: null, size: null, dims: null, exactOpen: false, exactUsed: false, hum: null, unsureOpen: false, signs: [], override: null };
  var S = Object.assign({}, INITIAL);
  var timer = null;
  var elMain = dlg.querySelector('.bf-quiz__main');
  var elFoot = dlg.querySelector('.bf-quiz__foot');
  var elProg = dlg.querySelector('.bf-quiz__progress');
  var elCounter = dlg.querySelector('.bf-quiz__counter');

  function roomObj() { for (var i = 0; i < ROOMS.length; i++) { if (ROOMS[i].key === S.room) { return ROOMS[i]; } } return null; }
  function area() { return S.dims ? num(S.dims[0]) * num(S.dims[1]) : NaN; }
  function sizeIdx(room) {
    if (S.exactUsed && S.dims) { var a = area(); if (!isNaN(a)) { return bucket(a); } }
    return S.size != null ? S.size : (room ? room.size : null);
  }
  function tierUp(cap) { var i = TIERS.indexOf(cap); return i < TIERS.length - 1 ? TIERS[i + 1] : cap; }
  function compute() {
    var room = roomObj();
    var sIdx = sizeIdx(room);
    var a = area();
    var sizeText = S.exactUsed && !isNaN(a) ? fmt(a) + ' m²' : (sIdx != null ? SIZES[sIdx].range : '—');
    var humIdx = S.hum != null ? S.hum : 1;
    var need = room ? [10, 14, 18, 22][sIdx != null ? sIdx : room.size] + [0, 2, 5][humIdx] + room.moist : 16;
    var recCap = need <= 12 ? 12 : need <= 16 ? 16 : need <= 20 ? 20 : 25;
    var guard = 0;
    while (PRODUCTS[recCap] && PRODUCTS[recCap].available === false && tierUp(recCap) !== recCap && guard++ < 4) { recCap = tierUp(recCap); }
    var curCap = S.override || recCap;
    var ri = TIERS.indexOf(recCap);
    var altCap = S.override ? recCap : TIERS[ri === 0 ? 1 : ri === TIERS.length - 1 ? ri - 1 : (need >= recCap ? ri + 1 : ri - 1)];
    if (SINGLE) { curCap = SINGLE.cap; altCap = null; }
    return { room: room, ofRoom: room ? room.of : T.room_default_of, sIdx: sIdx, sizeText: sizeText, humIdx: humIdx, need: need, recCap: recCap, curCap: curCap, altCap: altCap, best: PRODUCTS[curCap], alt: altCap != null ? PRODUCTS[altCap] : null };
  }

  function productUrl(p) {
    var sep = p.url.indexOf('?') > -1 ? '&' : '?';
    return p.url + sep + 'keuzehulp=' + encodeURIComponent((S.room || 'onbekend') + '-' + p.cap + 'l');
  }
  function stars(rating) {
    var pct = Math.max(0, Math.min(100, rating / 5 * 100));
    var row = ''; for (var i = 0; i < 5; i++) { row += '<svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' + ICONS.star + '</svg>'; }
    return '<span class="bf-quiz__stars" aria-hidden="true">' + row + '<span class="bf-quiz__stars-fill" style="width:' + pct + '%">' + row + '</span></span>';
  }
  function ratingLine(p) {
    if (p.shop) { return '<span class="bf-quiz__rating">' + stars(p.rating) + '<span>' + esc(DATA.shopRating) + '</span></span>'; }
    return '<span class="bf-quiz__rating">' + stars(p.rating) + '<span>' + String(p.rating).replace('.', T.decimal) + ' | ' + tp(T.reviews, { n: p.reviews }) + '</span></span>';
  }
  function img(src, cls, w, h, alt, eager) {
    if (!src) { return '<span class="' + cls + '"></span>'; }
    return '<img class="' + cls + '" src="' + esc(src) + '" width="' + w + '" height="' + h + '" alt="' + esc(alt || '') + '" loading="' + (eager ? 'eager' : 'lazy') + '">';
  }
  function roomImg(key) { return DATA.rooms[key] || ''; }
  function btn(cls, act, label, iconL, iconR, extra) {
    return '<button type="button" class="' + cls + '" data-act="' + act + '"' + (extra || '') + '>' + (iconL ? ic(iconL, 18) : '') + label + (iconR ? ic(iconR, 18) : '') + '</button>';
  }

  function renderHeader() {
    var isResult = S.step === 3;
    elCounter.textContent = isResult ? T.your_advice : tp(T.question_of, { n: S.step + 1 });
    var done = [!!S.room, S.step > 1, S.hum != null, isResult];
    var h = '';
    for (var i = 0; i < 4; i++) {
      var cls = 'bf-quiz__step' + (i <= S.step ? ' is-reached' : '') + (i === S.step ? ' is-current' : (done[i] ? ' is-done' : ''));
      var clickable = i < S.step && i < 3;
      h += '<button type="button" class="' + cls + '"' + (clickable ? ' data-act="go:' + i + '"' : ' disabled') + ' role="listitem" aria-current="' + (i === S.step ? 'step' : 'false') + '"><span class="bf-quiz__step-bar"></span><span class="bf-quiz__step-label">' + PROGRESS[i] + '</span></button>';
    }
    elProg.innerHTML = h;
  }

  function intro(eyebrow, title, sub) {
    return '<div class="bf-quiz__intro"><p class="bf-quiz__eyebrow">' + eyebrow + '</p><h1 class="bf-quiz__title">' + title + '</h1>' + (sub ? '<p class="bf-quiz__sub">' + sub + '</p>' : '') + '</div>';
  }
  function context(c) {
    if (!c.room || (S.step !== 1 && S.step !== 2)) { return ''; }
    var txt = S.step === 2 ? c.room.label + ' · ' + c.sizeText : c.room.label;
    return '<div class="bf-quiz__context"><span class="bf-quiz__chip">' + img(roomImg(c.room.key), '', 36, 36, c.room.label) + '<span>' + esc(txt) + '</span>' + btn('bf-quiz__link', 'go:0', T.change) + '</span></div>';
  }

  function renderStep0() {
    var h = intro(tp(T.question_of, { n: 1 }), T.q1_title, T.q1_sub);
    h += '<div class="bf-quiz__rooms">';
    ROOMS.forEach(function (r) {
      h += '<button type="button" class="bf-quiz__card bf-quiz__room' + (S.room === r.key ? ' is-on' : '') + '" data-act="room:' + r.key + '" aria-pressed="' + (S.room === r.key) + '">'
        + img(roomImg(r.key), 'bf-quiz__room-photo', 960, 645, r.label)
        + '<span class="bf-quiz__radio">' + ic('check', 14) + '</span>'
        + '<span class="bf-quiz__room-body"><span class="bf-quiz__room-label">' + r.label + '</span><span class="bf-quiz__room-desc">' + r.desc + '</span></span></button>';
    });
    return h + '</div>';
  }

  function renderStep1(c) {
    var h = context(c) + intro(tp(T.question_of, { n: 2 }), tp(T.q2_title, { room: c.ofRoom }), T.q2_sub);
    h += '<div class="bf-quiz__sizes">';
    SIZES.forEach(function (z, i) {
      h += '<button type="button" class="bf-quiz__card' + (c.sIdx === i ? ' is-on' : '') + '" data-act="size:' + i + '" aria-pressed="' + (c.sIdx === i) + '">'
        + '<span class="bf-quiz__size-top"><span>' + z.label + '</span><span class="bf-quiz__radio">' + ic('check', 14) + '</span></span>'
        + '<span class="bf-quiz__size-range">' + z.range + '</span><span class="bf-quiz__size-ex">' + z.example + '</span></button>';
    });
    h += '</div>';
    if (c.room) { h += '<p class="bf-quiz__note">' + tp(T.avg_room, { room: c.room.label.toLowerCase(), range: SIZES[c.room.size].avg }) + '</p>'; }
    h += '<div class="bf-quiz__exact">' + btn('bf-quiz__toggle', 'toggleExact', '<span class="bf-quiz__ic-accent">' + ic('ruler', 18) + '</span><span>' + T.exact_toggle + '</span><span class="bf-quiz__ic-muted">' + ic(S.exactOpen ? 'up' : 'down', 18) + '</span>', null, null, ' aria-expanded="' + S.exactOpen + '"');
    if (S.exactOpen) {
      var labels = [T.dim_length, T.dim_width, T.dim_height], hints = [T.hint_length, T.hint_width, T.hint_height];
      h += '<div class="bf-quiz__panel"><div class="bf-quiz__dims">';
      (S.dims || ['', '', '']).forEach(function (v, i) {
        h += '<div class="bf-quiz__dim"><span class="bf-quiz__dim-head"><span>' + labels[i] + '</span><span>m</span></span>'
          + '<span class="bf-quiz__stepper"><button type="button" data-act="dec:' + i + '" aria-label="' + T.less + '">' + ic('minus', 18) + '</button>'
          + '<input type="text" inputmode="decimal" value="' + esc(v) + '" data-dim="' + i + '" aria-label="' + tp(T.in_metres, { dim: labels[i] }) + '">'
          + '<button type="button" data-act="inc:' + i + '" aria-label="' + T.more + '">' + ic('plus', 18) + '</button></span>'
          + '<span class="bf-quiz__dim-hint">' + hints[i] + '</span></div>';
      });
      h += '</div><p class="bf-quiz__dims-out">' + tp(esc(T.dims_out), { area: '<strong data-out="area"></strong>', volume: '<strong data-out="volume"></strong>' }) + '</p></div>';
    }
    return h + '</div>';
  }
  function updateExactOut() {
    var a = area();
    var outA = elMain.querySelector('[data-out="area"]'), outV = elMain.querySelector('[data-out="volume"]');
    if (outA) { outA.textContent = !isNaN(a) ? fmt(Math.round(a)) + ' m²' : '—'; }
    if (outV) { var v = S.dims ? a * num(S.dims[2]) : NaN; outV.textContent = !isNaN(v) ? Math.round(v) + ' m³' : '—'; }
    var c = compute();
    var cards = elMain.querySelectorAll('.bf-quiz__sizes .bf-quiz__card');
    for (var i = 0; i < cards.length; i++) { cards[i].classList.toggle('is-on', c.sIdx === i); cards[i].setAttribute('aria-pressed', String(c.sIdx === i)); }
  }

  function renderStep2(c) {
    var h = context(c) + intro(tp(T.question_of, { n: 3 }), tp(T.q3_title, { room: c.ofRoom }), T.q3_sub);
    h += '<div class="bf-quiz__hums">';
    HUMS.forEach(function (m, i) {
      var on = S.hum === i && !S.unsureOpen;
      var bars = ''; for (var b = 0; b < 3; b++) { bars += '<span' + (b <= i ? ' style="background:' + m.color + '"' : '') + '></span>'; }
      h += '<button type="button" class="bf-quiz__card bf-quiz__hum' + (on ? ' is-on' : '') + '" data-act="hum:' + i + '" aria-pressed="' + on + '">'
        + '<span class="bf-quiz__hum-top"><span class="bf-quiz__hum-icon" style="background:' + m.tint + ';color:' + m.color + '">' + ic(m.icon, 22) + '</span>'
        + '<span class="bf-quiz__hum-txt"><span class="bf-quiz__hum-label">' + m.label + '</span><span class="bf-quiz__hum-rh">' + tp(T.humidity, { rh: m.rh }) + '</span></span>'
        + '<span class="bf-quiz__radio">' + ic('check', 14) + '</span></span>'
        + '<span class="bf-quiz__bars">' + bars + '</span><span class="bf-quiz__hum-signs">' + m.signs + '</span></button>';
    });
    h += '</div>';
    var lvl = S.signs.length ? Math.max.apply(null, S.signs.map(function (i) { return SIGNS[i].lvl; })) : 0;
    var guess = HUMS[lvl];
    h += '<div class="bf-quiz__unsure' + (S.unsureOpen ? ' is-open' : '') + '">'
      + '<button type="button" class="bf-quiz__unsure-btn" data-act="toggleUnsure" aria-expanded="' + S.unsureOpen + '"><span class="bf-quiz__unsure-icon">' + ic('help', 22) + '</span>'
      + '<span class="bf-quiz__unsure-txt"><span class="bf-quiz__unsure-title">' + T.unsure_title + '</span><span class="bf-quiz__unsure-sub">' + T.unsure_sub + '</span></span>'
      + '<span class="bf-quiz__ic-muted" style="display:flex;color:#5E5E60">' + ic(S.unsureOpen ? 'up' : 'down', 18) + '</span></button>';
    if (S.unsureOpen) {
      h += '<div class="bf-quiz__unsure-body"><div class="bf-quiz__signs">';
      SIGNS.forEach(function (g, i) {
        var on = S.signs.indexOf(i) > -1;
        h += '<button type="button" class="bf-quiz__sign' + (on ? ' is-on' : '') + '" data-act="sign:' + i + '" role="checkbox" aria-checked="' + on + '"><span class="bf-quiz__box">' + ic('check', 14) + '</span><span class="bf-quiz__sign-txt">' + g.text + '</span></button>';
      });
      h += '</div><div class="bf-quiz__guess"><span class="bf-quiz__guess-txt"><span class="bf-quiz__dot" style="background:' + guess.color + '"></span><span>'
        + (S.signs.length ? tp(T.guess_some, { level: guess.label.toLowerCase(), rh: guess.rh }) : T.guess_none)
        + '</span></span>' + btn('bf-btn bf-btn--primary bf-btn--md', 'useGuess', T.use_level, null, 'arrow') + '</div>'
        + '<div class="bf-quiz__info"><span class="bf-quiz__ic-accent">' + ic('gauge', 20) + '</span><p>' + T.info + '</p></div></div>';
    }
    return h + '</div>';
  }

  function renderResult(c) {
    var best = c.best, alt = c.alt, room = c.room;
    var diff = alt ? alt.price - best.price : 0;
    var diffTxt = !alt ? '' : diff === 0 ? eur(alt.price) : tp(diff < 0 ? T.price_less : T.price_more, { amount: eur(Math.abs(diff)) });
    var h = intro(tp(T.result_eyebrow, { room: c.ofRoom }), S.override ? tp(T.result_title_override, { name: best.name }) : tp(T.result_title, { name: best.name, room: c.ofRoom }), '');
    var points = [tp(T.point_area, { area: best.area }), tp(T.point_tank, { tank: best.tank }), ROOM_POINT[S.room] || ROOM_POINT.woonkamer];
    var isCurrent = DATA.current && DATA.current === best.handle;
    h += '<div class="bf-quiz__result"><section class="bf-quiz__best">'
      + '<div class="bf-quiz__best-media">' + img(best.image, '', 400, 400, best.name, true) + '<span class="bf-quiz__badge">' + (S.override ? T.badge_choice : T.badge_best) + '</span></div>'
      + '<div class="bf-quiz__best-body"><div><h2 class="bf-quiz__best-name">' + best.name + '</h2>' + ratingLine(best) + '</div>'
      + '<ul class="bf-quiz__points">' + points.map(function (p) { return '<li><span class="bf-quiz__ic-accent">' + ic('check', 18) + '</span><span>' + p + '</span></li>'; }).join('') + '</ul>'
      + '<div class="bf-quiz__price"><span class="bf-quiz__price-now">' + eur(best.price) + '</span>'
      + (best.compare > best.price ? '<span class="bf-quiz__price-was">' + eur(best.compare) + '</span><span class="bf-quiz__price-save">' + tp(T.save, { amount: eur(best.compare - best.price) }) + '</span>' : '') + '</div>'
      + '<div class="bf-quiz__cta"><a class="bf-btn bf-btn--primary bf-btn--lg bf-btn--block" href="' + esc(productUrl(best)) + '" data-act="product"' + (isCurrent ? ' data-current="1"' : '') + '>' + ic('arrow', 18) + tp(T.view, { name: best.name }) + '</a>'
      + (best.available === false ? '<p class="bf-quiz__cta-note">' + T.sold_out + '</p>' : '') + giftLine() + '</div>'
      + '<div class="bf-quiz__trust"><span><span class="bf-quiz__ic-accent">' + ic('truck', 18) + '</span>' + T.trust_shipping + '</span><span><span class="bf-quiz__ic-accent">' + ic('rotate', 18) + '</span>' + T.trust_trial + '</span><span><span class="bf-quiz__ic-accent">' + ic('shield', 18) + '</span>' + T.trust_warranty + '</span></div>'
      + '</div></section>';
    var rows = [
      { k: T.progress_room, v: room ? room.label : '—', go: 0 },
      { k: T.progress_size, v: c.sizeText, go: 1 },
      { k: T.progress_hum, v: S.hum != null ? HUMS[S.hum].label + ' · ' + HUMS[S.hum].rh : '—', go: 2 }
    ];
    h += '<section class="bf-quiz__why"><div><p class="bf-quiz__why-k">' + T.need_k + '</p><p class="bf-quiz__why-cap"><b>' + c.recCap + '</b><span>' + T.per_day + '</span></p></div>'
      + '<div class="bf-quiz__summary">' + rows.map(function (r) { return '<div class="bf-quiz__row"><span class="bf-quiz__row-txt"><span class="bf-quiz__row-k">' + r.k + '</span><span class="bf-quiz__row-v">' + esc(r.v) + '</span></span>' + btn('bf-quiz__link', 'go:' + r.go, T.change) + '</div>'; }).join('') + '</div>'
      + '<div class="bf-quiz__why-txt"><p>' + T.why_k + '</p><p>' + tp(T.why_text, { room: cap(c.ofRoom), size: esc(c.sizeText === SIZES[0].range ? T.why_small : c.sizeText), hum: HUMS[c.humIdx].label.toLowerCase() }) + ' ' + (SINGLE ? tp(T.why_single, { name: best.name, area: best.area }) : c.need > c.recCap ? tp(T.why_heavy, { name: PRODUCTS[c.recCap].name }) : tp(T.why_fit, { n: c.recCap }) + ' ' + (c.recCap > TIERS[0] ? T.why_smaller : T.why_enough)) + '</p></div></section></div>';
    if (!alt) { return h; }
    var altEyebrow = S.override ? T.alt_original : (alt.cap < best.cap ? T.alt_smaller : T.alt_bigger);
    var altReason = S.override ? tp(T.alt_reason_override, { room: c.ofRoom, n: c.recCap })
      : alt.cap < best.cap ? tp(T.alt_reason_smaller, { room: c.ofRoom })
      : T.alt_reason_bigger;
    h += '<section class="bf-quiz__alt"><div class="bf-quiz__alt-media">' + img(alt.image, '', 78, 78, alt.name, true) + '</div>'
      + '<div class="bf-quiz__alt-body"><span class="bf-quiz__alt-eyebrow">' + altEyebrow + '</span><span class="bf-quiz__alt-name">' + alt.name + '</span><span class="bf-quiz__alt-reason">' + altReason + '</span></div>'
      + '<div class="bf-quiz__tiles"><span class="bf-quiz__tile"><span class="bf-quiz__tile-k">' + T.tile_capacity + '</span><span class="bf-quiz__tile-v">' + tp(T.tile_l_per_day, { n: alt.cap }) + '</span></span><span class="bf-quiz__tile"><span class="bf-quiz__tile-k">' + T.tile_suitable + '</span><span class="bf-quiz__tile-v">' + alt.area + '</span></span><span class="bf-quiz__tile"><span class="bf-quiz__tile-k">' + T.tile_price + '</span><span class="bf-quiz__tile-v">' + diffTxt + '</span></span></div>'
      + '<a class="bf-btn bf-btn--secondary bf-btn--md" href="' + esc(productUrl(alt)) + '" data-act="product-alt"' + (DATA.current && DATA.current === alt.handle ? ' data-current="1"' : '') + '>' + tp(T.view, { name: alt.name }) + '</a></section>';
    return h;
  }

  function renderFooter() {
    var isResult = S.step === 3, n = narrow();
    var left = '';
    if (!n) {
      left = btn('bf-quiz__ghost', 'close', T.continue_shopping, 'arrowLeft');
      if (isResult) { left += btn('bf-quiz__ghost', 'restart', T.restart, 'rotate'); }
    }
    var right = '';
    if (S.step > 0) { right += btn('bf-btn bf-btn--secondary bf-btn--md', 'back', T.back, 'back'); }
    if (isResult && n) { right += btn('bf-btn bf-btn--secondary bf-btn--md bf-btn--grow', 'restart', T.restart, 'rotate'); }
    if (S.step === 1) {
      right += btn('bf-btn bf-btn--primary bf-btn--lg' + (n ? ' bf-btn--block' : ''), 'next', T.next, null, 'arrow');
    } else if (!isResult) {
      right += '<span class="bf-quiz__hint">' + (S.step === 0 ? T.hint_room : T.hint_level) + '</span>';
    }
    elFoot.innerHTML = '<div class="bf-quiz__foot-row"><div class="bf-quiz__foot-left">' + left + '</div><div class="bf-quiz__foot-right">' + right + '</div></div>';
  }

  function render() {
    var c = compute();
    renderHeader();
    elMain.innerHTML = S.step === 0 ? renderStep0() : S.step === 1 ? renderStep1(c) : S.step === 2 ? renderStep2(c) : renderResult(c);
    if (S.step === 1 && S.exactOpen) { updateExactOut(); }
    if (S.step === 3) { applyGift(); }
    renderFooter();
  }
  window.addEventListener('load', applyGift);

  function syncUrl() {
    try {
      var u = new URL(window.location.href);
      if (dlg.open) {
        u.searchParams.set('quiz', String(S.step + 1));
        if (S.room) { u.searchParams.set('room', S.room); } else { u.searchParams.delete('room'); }
        var c = compute();
        if (S.room && S.step > 0 && c.sIdx != null) { u.searchParams.set('size', String(c.sIdx)); } else { u.searchParams.delete('size'); }
        if (S.hum != null) { u.searchParams.set('hum', String(S.hum)); } else { u.searchParams.delete('hum'); }
      } else {
        ['quiz', 'room', 'size', 'hum'].forEach(function (k) { u.searchParams.delete(k); });
      }
      history.replaceState(history.state, '', u.toString());
    } catch (e) { /* oude browsers */ }
  }
  function readUrl() {
    try {
      var u = new URL(window.location.href);
      if (!u.searchParams.has('quiz')) { return false; }
      var room = u.searchParams.get('room');
      ROOMS.forEach(function (r) { if (r.key === room) { S.room = r.key; S.dims = dims(r); } });
      var size = parseInt(u.searchParams.get('size'), 10); if (S.room && size >= 0 && size <= 3) { S.size = size; }
      var hum = parseInt(u.searchParams.get('hum'), 10); if (hum >= 0 && hum <= 2) { S.hum = hum; }
      var step = parseInt(u.searchParams.get('quiz'), 10) - 1;
      if (!(step >= 0 && step <= 3)) { step = 0; }
      if (step > 0 && !S.room) { step = 0; }
      if (step === 3 && S.hum == null) { step = 2; }
      S.step = step;
      return true;
    } catch (e) { return false; }
  }

  function go(step) {
    clearTimeout(timer);
    S.step = step;
    track(step === 3 ? 'quiz_result' : 'quiz_step', { step: step + 1, room: S.room, humidity: S.hum });
    render();
    dlg.scrollTo({ top: 0, behavior: 'smooth' });
    syncUrl();
  }
  function advance(to) { clearTimeout(timer); timer = setTimeout(function () { go(to); }, 320); }
  function open() {
    if (dlg.open) { return; }
    if (typeof dlg.showModal === 'function') { dlg.showModal(); } else { dlg.setAttribute('open', ''); }
    document.documentElement.classList.add('bf-quiz-open');
    render();
    dlg.scrollTo(0, 0);
    track(S.step === 3 ? 'quiz_result' : 'quiz_step', { step: S.step + 1, room: S.room, humidity: S.hum });
    syncUrl();
    var first = dlg.querySelector('.bf-quiz__main button, .bf-quiz__main a'); if (first) { first.focus({ preventScroll: true }); }
  }
  function cleanup() {
    clearTimeout(timer);
    document.documentElement.classList.remove('bf-quiz-open');
    syncUrl();
  }
  function close() {
    track('quiz_exit', { step: S.step });
    if (dlg.open) { dlg.close(); } else { cleanup(); }
  }
  function setDim(i, v) { var d = (S.dims || ['', '', '']).slice(); d[i] = v; S.dims = d; S.exactUsed = true; S.override = null; }
  function stepDim(i, delta) {
    var v = num((S.dims || ['', '', ''])[i]);
    var nv = Math.max(0.5, Math.round(((isNaN(v) ? 0 : v) + delta) * 10) / 10);
    setDim(i, fmt(nv));
  }

  dlg.addEventListener('close', cleanup);
  dlg.addEventListener('input', function (e) {
    var t = e.target;
    if (t.hasAttribute && t.hasAttribute('data-dim')) {
      t.value = t.value.replace(/[^0-9.,]/g, '');
      setDim(parseInt(t.getAttribute('data-dim'), 10), t.value);
      updateExactOut();
    }
  });
  dlg.addEventListener('click', function (e) {
    var el = e.target.closest('[data-act]');
    if (!el || !dlg.contains(el)) { return; }
    var act = el.getAttribute('data-act'), parts = act.split(':'), kind = parts[0], arg = parts[1];
    switch (kind) {
      case 'close': close(); break;
      case 'back': go(Math.max(0, S.step - 1)); break;
      case 'next': go(S.step + 1); break;
      case 'go': go(parseInt(arg, 10)); break;
      case 'restart': S = Object.assign({}, INITIAL, { signs: [] }); go(0); break;
      case 'room':
        if (S.room !== arg) {
          var r = ROOMS.filter(function (x) { return x.key === arg; })[0];
          S.room = arg; S.size = null; S.dims = dims(r); S.exactUsed = false; S.override = null;
        }
        render(); advance(1); break;
      case 'size': S.size = parseInt(arg, 10); S.exactUsed = false; S.exactOpen = false; S.override = null; render(); advance(2); break;
      case 'toggleExact': S.exactOpen = !S.exactOpen; render(); break;
      case 'dec': stepDim(parseInt(arg, 10), arg === '2' ? -0.1 : -0.5); render(); break;
      case 'inc': stepDim(parseInt(arg, 10), arg === '2' ? 0.1 : 0.5); render(); break;
      case 'hum': S.hum = parseInt(arg, 10); S.unsureOpen = false; S.override = null; render(); advance(3); break;
      case 'toggleUnsure': S.unsureOpen = !S.unsureOpen; render(); break;
      case 'sign':
        var i = parseInt(arg, 10), at = S.signs.indexOf(i);
        if (at > -1) { S.signs.splice(at, 1); } else { S.signs.push(i); }
        render(); break;
      case 'useGuess':
        S.hum = S.signs.length ? Math.max.apply(null, S.signs.map(function (k) { return SIGNS[k].lvl; })) : 0;
        S.unsureOpen = false; S.override = null; go(3); break;
      case 'swap':
        var c = compute();
        S.override = S.override ? null : c.altCap; render(); dlg.scrollTo({ top: 0, behavior: 'smooth' }); break;
      case 'product':
      case 'product-alt':
        var cp = compute();
        var clicked = kind === 'product' ? cp.best : cp.alt;
        track('quiz_product_click', { product: clicked.handle, capacity: clicked.cap, recommended: kind === 'product' && !S.override, room: S.room });
        if (el.getAttribute('data-current') === '1') { e.preventDefault(); close(); window.scrollTo({ top: 0, behavior: 'smooth' }); }
        break;
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-survey], [data-bf-quiz-open], a[href="#keuzehulp"]');
    if (!t || t.hasAttribute('data-survey-id')) { return; }
    e.preventDefault();
    open();
  });
  window.addEventListener('resize', function () { if (dlg.open) { renderFooter(); } });

  window.BfQuiz = { open: open, close: close };
  if (readUrl()) { open(); }
})();
